import React from "react";
import { chat_close_icon } from "../../../../assets/images/Images";

interface FeedbackFormProps {
  feedbackText: string;
  onFeedbackChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: () => void;
  onClose: () => void;
  // Color customization props with defaults
  backgroundColor?: string;
  borderColor?: string;
  textColor?: string;
  buttonColor?: string;
  buttonHoverColor?: string;
  placeholderColor?: string;
}

const FeedbackForm: React.FC<FeedbackFormProps> = ({
  feedbackText,
  onFeedbackChange,
  onSubmit,
  onClose,
  // Color props with defaults from Tailwind config
  backgroundColor = "#FFFFFF", // bg-white
  borderColor = "#ECECEB", // line
  textColor = "#7D8175", // count-gray
  buttonColor = "#00B2C1", // brand-blue
  buttonHoverColor = "#00B2C1", // brand-blue
  placeholderColor = "#464C3B", // gray-300
}) => {
  return (
    <div 
      className="rounded-lg shadow-lg px-3 py-2 w-full"
      style={{
        backgroundColor,
        borderColor,
        borderWidth: '1px',
        borderStyle: 'solid'
      }}
    >
      <div className="flex justify-between items-center mb-1">
        <h2 
          className="text-xs mb-2"
          style={{ color: textColor }}
        >
          Tell us more:
        </h2>
        <img
          src={chat_close_icon || "/placeholder.svg"} // Replace with chat_close_icon
          alt="Close chat"
          onClick={onClose}
          className="cursor-pointer w-6 h-6"
        />
      </div>

      <input
        type="text"
        placeholder="Enter your response here"
        className="rounded-md p-2 mb-2 w-full text-xs focus:outline-none focus:ring-0"
        style={{
          borderColor,
          borderWidth: '1px',
          borderStyle: 'solid',
          color: placeholderColor
        }}
        value={feedbackText}
        onChange={onFeedbackChange}
      />
      <div className="flex justify-end gap-2">
        <button
          type="button"
          className="px-4 py-2 rounded text-xs text-white cursor-pointer"
          style={{
            backgroundColor: buttonColor
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = buttonHoverColor;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = buttonColor;
          }}
          onClick={onSubmit}
        >
          Submit
        </button>
      </div>
    </div>
  );
};

export default FeedbackForm;
